import isUnauthorized from '../../lib/isUnauthorized'
import reportAuthFailure from '../../lib/reportAuthFailure'
import TokenRefresher from '../../lib/tokenRefresher'


/**
 * Trades the refresh cookie for an access token, trying a second time when
 * the first attempt fails for any reason other than a refusal.
 *
 * @returns {Promise} resolves once the attempt is over, whether or not a token
 *   was issued, and rejects only if reporting a failure throws
 */
export default async function resumeSession() {
  try {
    await TokenRefresher.refresh()
  } catch (error) {
    // The server refuses both when there is no refresh cookie and when it no
    // longer accepts the one there is. Neither is a fault: the first is
    // somebody who has never signed in, and the second is a session that has
    // run its course.
    reportAuthFailure(error)

    // A refusal would only be repeated. A timeout or a 502 says nothing about
    // whether the session is still good, so the next attempt may succeed.
    if ( isUnauthorized(error) ) {
      return
    }

    await TokenRefresher.refresh()
      .catch(reportAuthFailure)
  }
}
